import {defineStore} from "pinia";

export const TherapiesStore = defineStore('therapies', {
    state: () => ({
        therapies: [],
    }),
    actions: {
        setTherapies(therapies) {
            this.therapies = therapies;
        },
        getTherapies() {
            return this.therapies;
        }
    },
});